(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tpp-footer-trust-bar"]) return;
  try {
    
  (function () {
    function initTrust(root) {
      if (!root || root.dataset.tppTrustReady === '1') return;
      root.dataset.tppTrustReady = '1';

      var track = root.querySelector('[data-tpp-trust-track]');
      var prev = root.querySelector('[data-tpp-trust-prev]');
      var next = root.querySelector('[data-tpp-trust-next]');
      if (!track || !prev || !next) return;

      var slides = track.querySelectorAll('[data-tpp-trust-slide]');
      if (slides.length < 2) return;

      function isSliderMode() {
        return window.matchMedia('(max-width: 1024px)').matches;
      }

      function updateButtons() {
        if (!isSliderMode()) {
          prev.hidden = true;
          next.hidden = true;
          return;
        }
        prev.hidden = false;
        next.hidden = false;
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= maxScroll;
      }

      function step(dir) {
        var slide = slides[0];
        if (!slide) return;
        var w = slide.getBoundingClientRect().width;
        track.scrollBy({ left: dir * w, behavior: 'smooth' });
      }

      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateButtons);
      }, { passive: true });
      window.addEventListener('resize', updateButtons, { passive: true });

      updateButtons();
    }

    function initAll() {
      document.querySelectorAll('[data-tpp-trust]').forEach(initTrust);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) {
        var el = e.target.querySelector('[data-tpp-trust]');
        if (el) initTrust(el);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpp-header-trust-bar"]) return;
  try {
    
  (function () {
    function initTrust(root) {
      if (!root || root.dataset.tppTrustReady === '1') return;
      root.dataset.tppTrustReady = '1';

      var track = root.querySelector('[data-tpp-trust-track]');
      var prev = root.querySelector('[data-tpp-trust-prev]');
      var next = root.querySelector('[data-tpp-trust-next]');
      if (!track || !prev || !next) return;

      var slides = track.querySelectorAll('[data-tpp-trust-slide]');
      if (slides.length < 2) return;

      function isSliderMode() {
        return window.matchMedia('(max-width: 1024px)').matches;
      }

      function updateButtons() {
        if (!isSliderMode()) {
          prev.hidden = true;
          next.hidden = true;
          return;
        }
        prev.hidden = false;
        next.hidden = false;
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= maxScroll;
      }

      function step(dir) {
        var slide = slides[0];
        if (!slide) return;
        var w = slide.getBoundingClientRect().width;
        track.scrollBy({ left: dir * w, behavior: 'smooth' });
      }

      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateButtons);
      }, { passive: true });
      window.addEventListener('resize', updateButtons, { passive: true });

      updateButtons();
    }

    function initAll() {
      document.querySelectorAll('[data-tpp-trust]').forEach(initTrust);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) {
        var el = e.target.querySelector('[data-tpp-trust]');
        if (el) initTrust(el);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpp-manufacturers-grid"] && !Shopify.designMode) return;
  try {
    
(function() {
  var desktopMq = window.matchMedia('(min-width: 750px)');
  var sections = document.querySelectorAll('.tpp-mfg-grid');

  sections.forEach(function(section) {
    var track = section.querySelector('[data-tpp-carousel]');
    var thumb = section.querySelector('[data-tpp-thumb]');
    var paginationEl = section.querySelector('[data-tpp-pagination]');
    var prevBtn = section.querySelector('[data-tpp-prev]');
    var nextBtn = section.querySelector('[data-tpp-next]');
    if (!track) return;

    var cards = track.querySelectorAll('.tpp-mfg-grid__card');
    var count = cards.length;
    if (count < 2) {
      if (paginationEl) paginationEl.style.display = 'none';
      if (prevBtn) prevBtn.hidden = true;
      if (nextBtn) nextBtn.hidden = true;
      return;
    }

    function cardStep() {
      var card = cards[0];
      if (!card) return track.clientWidth;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 16;
      return card.getBoundingClientRect().width + gap;
    }

    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function updateThumb() {
      if (!thumb) return;
      var scrollWidth = maxScroll();
      if (scrollWidth <= 0) return;
      var progress = track.scrollLeft / scrollWidth;
      var thumbWidth = (1 / count) * 100;
      var maxLeft = 100 - thumbWidth;
      thumb.style.width = thumbWidth + '%';
      thumb.style.left = (progress * maxLeft) + '%';
    }

    function updateNav() {
      var limit = maxScroll();
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft >= limit - 2;
      var canScroll = limit > 2;
      if (prevBtn) {
        prevBtn.disabled = !canScroll || atStart;
        prevBtn.hidden = desktopMq.matches ? !canScroll : false;
      }
      if (nextBtn) {
        nextBtn.disabled = !canScroll || atEnd;
        nextBtn.hidden = desktopMq.matches ? !canScroll : false;
      }
    }

    var scrollTimer;
    track.addEventListener('scroll', function() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function() {
        updateThumb();
        updateNav();
      }, 30);
    }, { passive: true });

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        track.scrollBy({ left: cardStep(), behavior: 'smooth' });
      });
    }

    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;

    track.addEventListener('mousedown', function(e) {
      if (desktopMq.matches) return;
      isDown = true;
      track.style.cursor = 'grabbing';
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
      e.preventDefault();
    });

    track.addEventListener('mouseleave', function() {
      isDown = false;
      if (!desktopMq.matches) track.style.cursor = 'grab';
    });

    track.addEventListener('mouseup', function() {
      isDown = false;
      if (!desktopMq.matches) track.style.cursor = 'grab';
    });

    track.addEventListener('mousemove', function(e) {
      if (!isDown || desktopMq.matches) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      var walk = (x - startX) * 1.5;
      track.scrollLeft = scrollLeft - walk;
    });

    function onMqChange() {
      updateThumb();
      updateNav();
    }
    if (desktopMq.addEventListener) {
      desktopMq.addEventListener('change', onMqChange);
    } else if (desktopMq.addListener) {
      desktopMq.addListener(onMqChange);
    }
    window.addEventListener('resize', onMqChange);

    updateThumb();
    updateNav();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
